'use client'

import React, { ReactNode, useRef } from 'react'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

export default function BlurButton({ children }: { children: ReactNode }) {
  const wrapRef = useRef<HTMLElement>(null)
  useGSAP(() => {
    gsap.matchMedia().add('(max-width: 768px)', () => {
      gsap.registerPlugin(ScrollTrigger)
      const idBtn = document.querySelector('#post-mb')
      if (idBtn) {
        const showAnim = gsap
          .from(idBtn, {
            opacity: 0.6,
            duration: 0.5,
            paused: true,
          })
          .progress(1)
        ScrollTrigger.create({
          trigger: wrapRef.current,
          start: () => `+=200 top`,
          end: () => `bottom -99999999`, // trick lor
          //   markers: true,
          scrub: true,
          onUpdate: (self) => {
            self.direction === -1 ? showAnim.play() : showAnim.reverse()
          },
        })
      }
    })
  })

  if (!React.isValidElement(children)) {
    return <div>Error: Invalid children element</div>
  }

  return React.cloneElement(children, { ...{ ref: wrapRef } })
}
